var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2811_28386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9237 6.84473C15.2364 8.37896 15.0136 9.97398 14.2925 11.3638C13.5715 12.7537 12.3957 13.8543 10.9614 14.4822C9.52705 15.1101 7.92081 15.2273 6.41053 14.8142C4.90025 14.4012 3.57721 13.4828 2.66206 12.2124C1.74691 10.9419 1.29496 9.39612 1.38158 7.83277C1.4682 6.26942 2.08816 4.78301 3.13806 3.62143C4.18796 2.45985 5.60435 1.6933 7.15102 1.44963C8.69769 1.20595 10.2812 1.49988 11.6373 2.28238",
    stroke: "white",
    strokeWidth: 1.36905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16113 7.52995L8.2147 9.58352L15.0599 2.73828",
    stroke: "white",
    strokeWidth: 1.36905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2811_28386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4286,
    height: 16.4286,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleTwo);
export default __webpack_public_path__ + "static/media/checkCircleTwo.4a675744d8d63ac1086ac189f4b4cb4f.svg";
export { ForwardRef as ReactComponent };